module.exports = __webpack_public_path__ + "img/vsu_logo_official.0714fd7a.png";